import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../../global/commonStyle';

const Group = styled.div`
  width: 100%;
  min-height: 560px;
  height: 100dvh;
  background-color: var(--background-secondary);
  margin: auto;
  overflow: auto;
  ${FlexCenter}
  ${mobile_xl(css`
    min-height: unset;
    align-items: flex-start;
    padding: var(--space-16) var(--space-0) var(--space-0);
  `)}
`;

const Content = styled.form`
  width: 100%;
  max-width: 558px;
  ${AlignCenter}
  flex-direction: column;
  background-color: var(--background-secondary);
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-32);
    max-width: -webkit-fill-available;
    padding: var(--space-0) var(--space-16);
    margin: var(--space-48) var(--space-0);
  `)}
`;

const Icon = styled.div`
  ${AlignCenter}
  cursor: pointer;
  ${mobile_xl(css`
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card-hover);
  border-radius: var(--border-radius-8);
  padding: var(--space-20);
  ${mobile_xl(css`
    padding: var(--space-18);
    gap: var(--space-32);
  `)}
`;

const Profile = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    margin-top: var(--space-16);
  `)}
`;

const Heading = styled.h2`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);

  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    gap: var(--space-20);
  `)}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const InputValue = styled.input`
  ${Typography.body_lg_medium}
  background-color: var(--background-primary);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-7) var(--space-12);
  border-radius: var(--border-radius-6);
  outline: none;
  &:focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    ${Typography.body_lg_medium}
    color:  var(--text-placeholder);
  }
  ${mobile_xl(css`
    padding: var(--space-12);
  `)}
`;

const Endblock = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-32);
  `)}
`;

const TextFormat = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const FormContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
`;

const ProfileView = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-6);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const ProfileContent = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;
const InputDiv = styled.div`
  position: relative;
  cursor: pointer;
`;
const Input = styled.input`
  min-width: 414px;
  padding: var(--space-7) var(--space-12);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  cursor: pointer;
  ${Typography.body_lg}
  ::placeholder {
    color: var(--text-secondary);
  }
  &:focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
  ${mobile_xl(css`
    min-width: calc(100vw - 90px);
  `)}
`;

const IconDiv = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }

  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

export {
  Group,
  Content,
  Icon,
  Title,
  FormBlock,
  Profile,
  Heading,
  Text,
  SubBlock,
  Item,
  Label,
  InputValue,
  Endblock,
  TextFormat,
  FormContent,
  ProfileView,
  ProfileContent,
  InputDiv,
  Input,
  IconDiv
};
